import { Validator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/Validator';
import { CommonStateViewModelValidator } from './CommonStateViewModelValidator';
export class GlobalStateViewModelValidator extends Validator {
    constructor() {
        super();
        this.commonStateModelValidator = new CommonStateViewModelValidator();
    }
    validate(model) {
        this.commonStateModelValidator.validate(model);
    }
}
